// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../resources/dot-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#SolutionsSectionOne {
  background-color: #e0e4fb;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: -80px 150px;
  background-repeat: no-repeat;
  background-size: 11% auto;
  height: auto !important;
  width: 100%;
  padding-top: 35px;
  display: flex;
  flex-direction: row;
  position: relative;
  padding-bottom: 50px;
}

.SolutionsSectionOne-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6%;
  padding-left: 100px;
  width: 64%;
}

#SolutionsSectionOne-left-head {
  width: 80%;
  margin-top: 10%;
  font-size: 38px;
  font-weight: 500;
  line-height: 1.2em;
  color: #CF6930;
}

#SolutionsSectionOne-left-middle {
  display: flex;
  flex-direction: row;
  width: 60%;
}

#SolutionsSectionOne-left-middle-left {
  text-align: left;
  margin-left: -70px;
  font-size: 15px;
  line-height: 1.86;
  border-right: unset !important;
}

#SolutionsSectionOne-discovermore {
  color: #EC6927;
  margin-top: 2%;
  cursor: pointer;
}

#SolutionsSectionOne-left-middle-right {
  text-align: left;
  margin-left: 5%;
}

#SolutionsSectionOne-left-middle-bottom {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 5%;
}

#SolutionsSectionOne-schedule-a-demo {
  width: 130px;
  height: 33px;
  background: #EC6927;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  border: none;
  color: white;
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  cursor: pointer;
}

#SolutionsSectionOne-explore-how {
  font-style: normal;
  font-weight: normal;
  font-size: 13.5px;
  width: 25%;
  line-height: 16px;
}

.SolutionsSectionOne-right {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#SolutionsSectionOne-page1-banner {
  width: 100%;
}

#SolutionsSectionOne-page1-video {
  position: absolute;
  margin-top: 50px;
}

.subtitle-video {
  font-weight: bold;
  margin-top: -50px;
}

#SolutionsSectionOne-image-bg {
  margin-top: 75px;
}`, "",{"version":3,"sources":["webpack://./src/components/Solutions/SectionOne/sectionOne.scss"],"names":[],"mappings":"AAAI;EACI,yBAAA;EACA,yDAAA;EACA,gCAAA;EACA,4BAAA;EACA,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AACR;;AAEI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,mBAAA;EACA,UAAA;AACR;;AAGI;EACI,UAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAAR;;AAGI;EACI,aAAA;EACA,mBAAA;EACA,UAAA;AAAR;;AAII;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,8BAAA;AADR;;AAII;EACI,cAAA;EACA,cAAA;EACA,eAAA;AADR;;AAGI;EACI,gBAAA;EACA,eAAA;AAAR;;AAGI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,OAAA;AAAR;;AAGI;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAAR;;AAGI;EACI,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,iBAAA;AAAR;;AAGI;EAEI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AADR;;AAII;EACI,WAAA;AADR;;AAKI;EACI,kBAAA;EACA,gBAAA;AAFR;;AAKI;EACI,iBAAA;EACA,iBAAA;AAFR;;AAKI;EACI,gBAAA;AAFR","sourcesContent":["    #SolutionsSectionOne{\n        background-color: #e0e4fb;\n        background-image: url(../../../resources/dot-bg.png);\n        background-position: -80px 150px;\n        background-repeat: no-repeat;\n        background-size: 11% auto;\n        height: auto !important;\n        width: 100%;\n        padding-top: 35px;\n        display: flex;\n        flex-direction: row;\n        position: relative;\n        padding-bottom: 50px;\n    }\n\n    .SolutionsSectionOne-left{\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 6%;\n        padding-left: 100px;\n        width: 64%;\n\n    }\n\n    #SolutionsSectionOne-left-head{\n        width: 80%;\n        margin-top: 10%;\n        font-size: 38px;\n        font-weight: 500;\n        line-height: 1.2em;\n        color: #CF6930;\n    }\n\n    #SolutionsSectionOne-left-middle{\n        display: flex;\n        flex-direction: row;\n        width: 60%;\n        \n    }\n\n    #SolutionsSectionOne-left-middle-left{\n        text-align: left;\n        margin-left: -70px;\n        font-size: 15px;\n        line-height: 1.86;\n        border-right: unset !important;\n    }\n\n    #SolutionsSectionOne-discovermore{\n        color: #EC6927;\n        margin-top: 2%;\n        cursor: pointer;\n    }\n    #SolutionsSectionOne-left-middle-right{\n        text-align: left;\n        margin-left: 5%;\n    }\n\n    #SolutionsSectionOne-left-middle-bottom{\n        width: 80%;\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-start;\n        gap: 5%;\n    }\n\n    #SolutionsSectionOne-schedule-a-demo{\n        width: 130px;\n        height: 33px;\n        background: #EC6927;\n        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n        border-radius: 3px;\n        border: none;\n        color: white;\n        font-style: normal;\n        font-weight: normal;\n        font-size: 13.5px;\n        cursor: pointer;\n    }\n\n    #SolutionsSectionOne-explore-how{\n        font-style: normal;\n        font-weight: normal;\n        font-size: 13.5px;\n        width: 25%;\n        line-height: 16px;\n    }\n\n    .SolutionsSectionOne-right{\n\n        width: 50%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n    }\n\n    #SolutionsSectionOne-page1-banner{\n        width: 100%;\n        \n    }\n\n    #SolutionsSectionOne-page1-video{\n        position: absolute;\n        margin-top: 50px;\n    }\n\n    .subtitle-video{\n        font-weight: bold;\n        margin-top: -50px;\n    }\n\n    #SolutionsSectionOne-image-bg{\n        margin-top: 75px;\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
